"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchPackageFamiliesOutputDtoSchema = exports.searchPackageFamiliesInputDtoSchema = void 0;
const zod_1 = require("zod");
const search_dto_js_1 = require("../search.dto.js");
exports.searchPackageFamiliesInputDtoSchema = zod_1.z.object({
    search: search_dto_js_1.packageFamilySearchSchema,
});
exports.searchPackageFamiliesOutputDtoSchema = zod_1.z.object({
    pkgFamilies: zod_1.z
        .object({
        id: zod_1.z.string(),
        name: zod_1.z.string(),
    })
        .array(),
});
//# sourceMappingURL=search-package-families.dto.js.map